import { useConfigSlice } from '../slices/config/selectors';

export const useAutoplayHiddenFlag = (): boolean => {
  const casinoConfig = useConfigSlice.casinoConfig()?.hideAutoplay || false;
  const complianceConfig = useConfigSlice.compliance()?.hideAutoplay || false;
  const extendedAutoplay = useConfigSlice.compliance()?.extendedAutoplay || false;

  return (extendedAutoplay && casinoConfig) || complianceConfig;
};
